import { algoliasearch } from 'algoliasearch'

export const algoliaAppId = process.env.NEXT_PUBLIC_ALGOLIA_APP_ID || ''
export const algoliaAdminApiKey = process.env.ALGOLIA_ADMIN_API_KEY || ''
export const algoliaSearchApiKey = process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY || ''
export const algoliaEnvironmentIndex = process.env.NEXT_PUBLIC_ALGOLIA_INDEX || ''

/**
 * Check if Algolia is configured for server-side admin operations (indexing, settings).
 * Validates: NEXT_PUBLIC_ALGOLIA_APP_ID, ALGOLIA_ADMIN_API_KEY, NEXT_PUBLIC_ALGOLIA_INDEX
 */
export function isAlgoliaAdminConfigured(): boolean {
  return !!(algoliaAppId && algoliaAdminApiKey && algoliaEnvironmentIndex)
}

/**
 * Check if Algolia is configured for client-side search operations.
 * Validates: NEXT_PUBLIC_ALGOLIA_APP_ID, NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY, NEXT_PUBLIC_ALGOLIA_INDEX
 */
export function isAlgoliaSearchConfigured(): boolean {
  return !!(algoliaAppId && algoliaSearchApiKey && algoliaEnvironmentIndex)
}

// Lazy initialization of the Algolia client
let algoliaClient: ReturnType<typeof algoliasearch> | null = null

export function getAlgoliaClient() {
  if (!algoliaClient) {
    if (!isAlgoliaAdminConfigured()) {
      throw new Error('[Algolia Plugin] Missing required environment variables. See .env.example.')
    }
    algoliaClient = algoliasearch(algoliaAppId, algoliaAdminApiKey)
  }
  return algoliaClient
}
